"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _fileSaver = require("file-saver");
var XLSX = _interopRequireWildcard(require("xlsx"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const s2ab = s => {
  if (typeof ArrayBuffer !== "undefined") {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  } else {
    var buffer = new Array(s.length);
    for (var j = 0; j !== s.length; ++j) {
      buffer[j] = s.charCodeAt(j) & 0xff;
    }
    return buffer;
  }
};
const export_json_to_excel = (id, type, _ref) => {
  let {
    data,
    columnIndex,
    fileName = 'export'
  } = _ref;
  const fitToCell = (json, cellType) => {
    const cellDimension = [];
    const rowHeights = [];
    for (const property in json[0]) {
      if (cellType === 'column') {
        cellDimension.push({
          wch: Math.max(property ? property.toString().length : 0, ...json.map(obj => obj[property] ? obj[property].toString().length : 0))
        });
      }
      if (cellType === 'row') {
        cellDimension.push({
          hpx: 14
        });
      }
    }
    return cellDimension;
  };
  var ws = XLSX.utils.json_to_sheet(data);
  ws['!cols'] = fitToCell(data, 'column');
  ws['!rows'] = fitToCell(data, 'row');

  // add to workbook
  var wb = XLSX.utils.book_new();
  const formatColumn = (worksheet, col, fmt) => {
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    // note: range.s.r + 1 skips the header row
    for (let row = range.s.r + 1; row <= range.e.r; ++row) {
      const ref = XLSX.utils.encode_cell({
        r: row,
        c: col
      });
      if (worksheet[ref] && worksheet[ref].t === 's') {
        worksheet[ref].z = fmt;
      }
    }
  };
  // To refrain 'ratio' fields to be represented as `time` values.
  const format = '@';

  // Add index of column which required filtering
  if (columnIndex.length) {
    for (let col of columnIndex) {
      formatColumn(ws, col, format);
    }
  }
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
  var wbout = XLSX.write(wb, {
    bookType: type,
    bookSST: true,
    compression: true,
    type: "binary"
  });
  var fname = `${fileName}${type}`;
  try {
    (0, _fileSaver.saveAs)(new Blob([s2ab(wbout)], {
      type: "application/octet-stream"
    }), fname);
  } catch (e) {
    if (typeof console !== "undefined") console.log(e, wbout);
  }
  return wbout;
};
const donwloadExcel = args => {
  var type = "xlsx";
  return export_json_to_excel("table", type || "xlsx", args);
};
var _default = exports.default = donwloadExcel;